/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Form, Modal, Input, Select, notification } from 'antd';
import emiter, {
	EVENT_CARRENTAL_EDITTABLE_ADDROW,
	EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE,
	EVENT_CARRENTAL_ROLE_SEARCH_LIST
} from '../../../../events';
import { getAllUsers, bindUsers } from '../../../../hooks/carRental/employee';

interface PropsType {
	enums?: any;
}

const SPAssociatedEmployeeModal: React.FC<PropsType> = props => {
	const [form] = Form.useForm();
	const [data, setData] = useState<any>();
	const [open, setOpen] = useState(false);
	const [userList, setUserList] = useState([]);

	const mainFormFields = {
		juesemingcheng: {
			name: 'role_name',
			label: '角色名称',
		},
		guanlianyuangong: {
			name: 'user_list',
			label: '关联员工',
			required: true,
			message: '请选择关联员工',
			placeholder: '请选择',
		},
	};

	const openModal = (data: any) => {
		setData(data);
		setOpen(true);
		const myUserList: any = [];
		if (data?.user_list && data?.user_list.length) {
			data.user_list.forEach((item: any) => {
				myUserList.push(item.uid);
			});
		}
		form.setFieldsValue({ role_name: data?.name, user_list: myUserList });
	};

	const onClose = () => {
		form.resetFields();
		setOpen(false);
	};

	const onFinish = () => {
		form.validateFields().then((fieldsValue: any) => {
			const params = {
				uid_list: fieldsValue.user_list,
				role_code: data.code,
			};
			bindUsers(params).then((res: any) => {
				if (res?.data?.succeed_no && !res?.data?.error_list) {
					notification.open({
						message: '关联提示',
						description: '角色绑定成功',
					});
				} else if (res?.data?.error_list && res?.data?.error_list.length) {
					const failUsers: any = [];
					res.data.error_list.forEach((itemUser: any) => {
						failUsers.push(itemUser.user_name);
					});
					const failUserStr = failUsers.length ? failUsers.join(',') : '';
					notification.open({
						message: '关联提示',
						description: `绑定角色成功${res.data.succeed_no}人，失败${failUsers.length}人（${failUserStr}），请稍后尝试重新绑定！`,
					});
				}
				onClose();
				emiter.emit(EVENT_CARRENTAL_ROLE_SEARCH_LIST);
			});
		});
	};

	const getUserList = () => {
		getAllUsers().then((res: any) => {
			if (res.errno === 0) {
				setUserList(res.data);
			}
		});
	};

	useEffect(() => {
		getUserList();
		emiter.on(EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE, openModal);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE)
		}
	}, []);

	return (
		<Modal title="关联员工" centered open={open} onOk={onFinish} onCancel={onClose}>
			<Form form={form} labelCol={{ span: 5 }}>
				<Form.Item name={mainFormFields.juesemingcheng.name} label={mainFormFields.juesemingcheng.label}>
					<Input disabled />
				</Form.Item>
				<Form.Item
					name={mainFormFields.guanlianyuangong.name}
					label={mainFormFields.guanlianyuangong.label}
					rules={[
						{
							required: mainFormFields.guanlianyuangong.required,
							message: mainFormFields.guanlianyuangong.message,
						},
					]}
				>
					<Select
						placeholder={mainFormFields.guanlianyuangong.placeholder}
						mode="multiple"
						showSearch={false}
					>
						{userList &&
							userList
								.filter((user: any) => !user.is_supplier)
								.map((item: any) => (
									<Select.Option value={item.uid} key={item.uid}>
										{item.user_name}
									</Select.Option>
								))}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default SPAssociatedEmployeeModal;
